import { FeatureName, useFeatureFlags } from "../hooks/useFeatureFlags";

export interface FeatureProps extends React.PropsWithChildren<{}> {
	name: FeatureName;
	is_active: boolean;
}

const Feature = (props: FeatureProps) => {
	const { isFeature } = useFeatureFlags();
	if (isFeature(props.name, props.is_active)) {
		return <>{props.children}</>;
	} else {
		return <></>;
	}
};

export default Feature;
